/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [vp.PortalVideoResponse, (requestParams: vp.IsPartner) => void, () => void];

function useFetchPortalVideos({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.IsPartner>();
  const [response, setResponse] = useState<vp.PortalVideoResponse>({
    VideoList: {},
    Categories: {},
  });

  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: vp.IsPartner) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');

      const res = await api.fetchPortalVideos(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.IsPartner) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setResponse({
        VideoList: {},
        Categories: {},
      });
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchPortalVideos);
